import { Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/layout/Header.js';
import { RequireAuth } from './components/RequireAuth.js';
import { ClientDetail } from './pages/ClientDetail.js';
import { Clients, ClientsIndex } from './pages/Clients.js';
import { ClientAdmins } from './pages/clients/Admins.js';
import { FusionConnections } from './pages/clients/FusionConnections.js';
import { GitHubOptions } from './pages/clients/GitHubOptions.js';
import { Licenses } from './pages/clients/Licenses.js';
import { OAuthApps } from './pages/clients/OAuthApps.js';
import { ClientSettings } from './pages/clients/Settings.js';
import { SystemLogs } from './pages/clients/SystemLogs.js';
import { WorkfrontConnections } from './pages/clients/WorkfrontConnections.js';
import { Home } from './pages/Home.js';
import { Login } from './pages/Login.js';
import { NotFound } from './pages/NotFound.js';
import { Profile } from './pages/Profile.js';

/**
 * Top-level route tree. The shell is the legacy-style dark theme:
 * Flowbite Navbar header (logo + Dashboard/Clients pills + avatar
 * dropdown) over a single content `<main>`.
 *
 * `/clients` is a split-pane parent route — the sidebar list is
 * always visible, the right pane is an outlet that hosts either
 * `ClientsIndex` (auto-redirect to first tenant) or
 * `/clients/:id/<sub-tab>` for a selected tenant. Sub-tabs are nested
 * routes so the URL is shareable + bookmarkable for any of the seven
 * sections.
 */
export function App(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex grow flex-col">
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />

          <Route
            path="/clients"
            element={
              <RequireAuth>
                <Clients />
              </RequireAuth>
            }
          >
            <Route index element={<ClientsIndex />} />
            <Route path=":id" element={<ClientDetail />}>
              <Route index element={<Navigate to="licenses" replace />} />
              <Route path="licenses" element={<Licenses />} />
              <Route path="fusion-connections" element={<FusionConnections />} />
              <Route path="workfront-connections" element={<WorkfrontConnections />} />
              <Route path="oauth-apps" element={<OAuthApps />} />
              <Route path="github-opts" element={<GitHubOptions />} />
              <Route path="admins" element={<ClientAdmins />} />
              <Route path="system-logs" element={<SystemLogs />} />
              <Route path="settings" element={<ClientSettings />} />
            </Route>
          </Route>

          <Route
            path="/profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}
